<template>
    <!-- 创建班级二维码 -->
  <div class="my-createSucc">
    <div class="head">
      <div class="icon-succ"></div>
      <p class="title">班级创建成功</p>
    </div>
    <div class="qr">
      <div class="qr-tips">班级二维码已生成</div>
      <div class="qr-code">
        <QrCode :qrUrl="qrCodeUrl" ref="qrcode"></QrCode>
        <p class="qr-title">邀请您进入“{{className}}”</p>
      </div>
    </div>
    <div class="btn" @click="handleBackGrade">返回班级主页</div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode'
import withRouteTracking from '@/utils/withRouteTracking'
import {debounce} from '@/utils/util'
const UserProfile = {
  name: 'createGradeSucc',
  data() {
    return {
      qrCodeUrl: '',
      classId: '',
      className: ''
    }
  },
  components: {
    QrCode
  },
  created() {
    this.classId = this.$route.query.classId
    this.className = this.$route.query.className
    this.qrCodeUrl = `/gradeInterpage?classId=${this.classId}&sourceShare=1`
    // this.qrCodeUrl = `/gradeHomePage?classId=${this.classId}&sourceShare=1`
  },
  methods: {
    handleBackGrade: debounce(function() {
      this.$router.push({
        path: '/gradeHomePage',
        query: {
          classId: this.classId
        }
      })
    }, 500)
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-createSucc{
  position: relative;
  background: #FFF2EC;
  padding:20px 20px 24px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .head{
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-succ{
      background: url("../../../assets/images/grade/grade-succ.png") no-repeat center
      center / 100% 100%;
      // width: 151px;
      // height: 167px;
      width: 130px;
      height: 143px;
    }
    .title{
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 16px;
      color: #1A1A1A;
      line-height: 24px;
      text-align: center;
    }
  }
  .qr{
      margin-top: 12px;
      // flex: 1;
      position: relative;
      height: calc(100vh - 87px - 12px - 42px - 10px);
      margin-bottom: 10px;
      .qr-tips{
          width: 181px;
          height: 32px;
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255,91,12,0.25);
          border-radius: 22px;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -90px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 30px;
          text-align: center;
          z-index: 2;
      }
      .qr-code{
          width: 100%;
          // height: 120px;
          background: #fff;
          border-radius: 12px;
          margin-top: 16px;
          padding:8px 10px 10px;
          box-sizing: border-box;
          .qr-url{
              padding:0 9px;
              width: 226px;
              height: 226px;
          }
          .qr-title {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: bold;
              font-size: 18px;
              color: #000000;
              line-height: 21px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              position: relative;
              top: -10px;
          }
      }

  }
  .btn{
      // margin-top: 16px;
      width: 100%;
      height: 42px;
      background: #EB1700;
      box-shadow: 0px 2px 4px 0px rgba(255,91,12,0.25);
      border-radius: 22px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 42px;
  }

}
@media screen and (min-width: 414px) {
  /* 自定义提示点 */
  .my-createSucc{
    padding: 30px 20px 32px;
    .qr{
      margin-top: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/createGradeSucc.vue